import React, { useRef } from 'react';
import ReactSelect, { Props } from 'react-select';
import { SelectOption } from '../..';
import { selectStyle } from '../../selectStyle';
import { selectTheme } from '../../selectTheme';
import { DefaultClearIndicator } from '../default/ClearIndicator';
import { DefaultOption } from '../default/Option';
import TransparentMenu from './Menu';
import TransparentValueContainer from './ValueContainer';
import useIsFocused from '../../../../hooks/useIsFocused';
import { Size } from '../../../../utils/types/Size';
import { TransparentDropdownIndicator } from './DropdownIndicator';

type TransparentSelectPropTypes = {
  options?: SelectOption[];
  size?: Size;
} & Omit<Props<SelectOption, false>, 'options'>;

const TransparentSelect = (props: TransparentSelectPropTypes) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isFocused] = useIsFocused(containerRef, `.custom-menu`);

  return (
    <div ref={containerRef}>
      <ReactSelect<SelectOption>
        isSearchable={false}
        {...props}
        classNamePrefix='tags'
        placeholder={<div className='text-truncate'>{'Select...'}</div>}
        components={{
          ClearIndicator: DefaultClearIndicator,
          DropdownIndicator: TransparentDropdownIndicator,
          Option: DefaultOption,
          Menu: TransparentMenu,
          SingleValue: () => null,
          ValueContainer: TransparentValueContainer,
          ...props.components,
        }}
        menuIsOpen={isFocused}
        theme={selectTheme}
        styles={selectStyle(props.size ?? 'lg', undefined, 'transparent')}
      />
    </div>
  );
};

export default TransparentSelect;
